import { mapGetters } from "vuex";

const FIELD_VALID = { valid: true };
const FIELD_INVALID = { valid: false };

export default {
  data () {
    return {
      locations: undefined,
      location: null
    }
  },
  computed: {
    ...mapGetters('lk', {
      isUserAuth: 'isUserAuth'
    }),
  },
  methods: {
    setupField (field) {
      switch (field.typeField) {
        //  1 - Текстовое поле (одна строка)
        //  2 - Текстовое поле (Несколько строк)
        //  3 - Цифровое поле
        //  4 - E-mail с валидацией
        //  5 - Дата
        //  6 - Загрузка файла
        //  7 - Выпадающий список с одним вариантом
        //  8 - Выпадающий список с несколькими вариантами
        //  9 - Варианты ответов в виде чекбоксов
        // 10 - Варианты ответов в виде картинок
        // 11 - Номер телефона
        // 12 - Поле заглушка
        // 13 - Ссылка
        // 14 - Варианты ответов в виде радио-кнопок
        // 15 - Город с автокомплитом для неавторизованного пользователя
        // 16 - Организация с автокомплитом для неавторизованного пользователя
        // 17 - Скрытый тип поля (решили не трогать 12ый тип поля на всякий случай)
        case 1:
          field.type = 'text';
          field.pattern = /\S{2,}/i;
          break;

        case 2:
          field.type = 'textarea';
          field.pattern = /\S{2,}/i;
          break;

        case 3:
          field.type = 'number';
          field.pattern = /^(\d)+$/;
          break;

        case 4:
          field.type = 'text';
          field.pattern = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
          break;

        case 5:
          field.type = 'date-picker';
          field.pattern = /\S{2,}/i;
          break;

        case 6:
          field.type = 'dropzone';
          field.pattern = '';
          this.dropzoneOptions.acceptedFiles = field.extensions.split(',').map(item => '.' + item).join(',');
          break;

        case 7:
        case 8:
          field.type = 'select';
          field.pattern = '';
          field.value = [];
          break;

        case 9:
          field.type = 'checkbox';
          field.pattern = '';
          field.list.forEach(item => item.checked = false);
          break;

        case 10:
          field.type = 'images';
          field.pattern = '';
          field.list.forEach(item => item.checked = false);
          break;

        case 11:
          field.type = 'phone';
          field.pattern = '';
          field.value = field.defaultValue ? field.defaultValue.toString().substr(1) : ''
          break;

        case 12:
          field.type = 'hidden';
          field.pattern = '';
          break;

        case 13:
          field.type = 'text';
          field.pattern = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
          break;

        case 14:
          field.type = 'radio';
          field.pattern = '';
          field.value = field.list[0].id;
          break;
        case 15:
          if (field.isAuth && this.isUserAuth) {
            field.type = 'text';
            field.pattern = /\S{2,}/i;
            break;
          }

          field.type ='dadata-city'
          field.pattern = '';
          field.value = null;
          break;

        case 16: 
          if (field.isAuth && this.isUserAuth) {
            field.type = 'text';
            field.pattern = /\S{2,}/i;
            break;
          }

          field.type ='dadata-organisation'
          field.pattern = '';
          field.value = null;
          break;

        case 17:
          field.type = 'view-hidden';
          field.pattern = '';
          break;

        default:
          field.type = 'text';
          field.pattern = /\S{2,}/i;
          break;
      }
    },
    validateField (field) {
      field.error = false;

      if (
        field.pattern !== '' &&
        (!field.requiredField ? field.value !== '' : true)
      ) {
        field.valid = true;
        if (!field.pattern.test(field.value.trimEnd())) {
          field.error = true;
          field.valid = false;

          return FIELD_INVALID;
        }
      }

      if (field.requiredField && !field.value) {
        field.valid = false;
        field.error = true;
          
        return FIELD_INVALID;
      }

      if (
        field.requiredField &&
        field.value === '' &&
        field.pattern !== ''
      ) {
        field.error = true;
        field.valid = false;
          
        return FIELD_INVALID;
      }

      if (
        field.requiredField &&
        field.type === 'dropzone' &&
        this.$refs.dropzone[0].getAcceptedFiles().length === 0
      ) {
        field.error = true;
        field.valid = false;
          
        return FIELD_INVALID;
      }

      if (
        field.type === 'select' &&
        field.requiredField &&
        field.value.length === 0
      ) {
        field.error = true;
        field.valid = false;
          
        return FIELD_INVALID;
      }

      if (
        field.type === 'radio' &&
        field.requiredField &&
        field.value.length === 0
      ) {
        field.error = true;
        field.valid = false;
          
        return FIELD_INVALID;
      }

      if (
        field.type === 'checkbox' &&
        field.requiredField &&
        !field.list.some(el => el.checked)
      ) {
        field.error = true;
        field.valid = false;
          
        return FIELD_INVALID;
      }

      return FIELD_VALID;
    },
    appendField (field, fd) {
      if (field.type === 'dropzone') {
        for (const item of this.$refs.dropzone[0].getAcceptedFiles()) {
          fd.append(field.id, item);
        }

        return;
      } 
      
      if (field.type === 'select') {
        for (const item of field.value) {
          fd.append(
            field.id + (field.typeField === 8 ? '[]' : ''),
            item.id
          );
        }

        return;
      }
      
      if (field.type === 'date-picker') {
        fd.append(field.id, this.formatDate(field.value));
        return;
      } 
      
      if (field.type === 'checkbox' || field.type === 'images') {
        for (const item of field.list) {
          if (!item.checked) continue;
        
          fd.append(`${field.id}[]`, item.id);
        }

        return;
      }

      if (field.type === 'dadata-organisation') {

        for (const key in field.value) {
          switch (key) {
            case 'region':
              fd.append(`${field.id}[district]`, field.value[key])
              continue;
            case 'federal_district':
            case 'region_with_type':
              continue; 
            default:
              fd.append(`${field.id}[${key}]`, field.value[key])
              continue;
          }

        }

        return;
      } 
      
      if (field.type === 'dadata-city') {
        fd.append(field.id, field.value.city);

        return;
      } 

      fd.append(field.id, field.value.toString().trim());
    },
    handleFieldFocus (field) {
      field.error = false;
    },
  }
}


// WEBPACK FOOTER //
// ./src/templates/components/mixins/form-field.js